<template lang="pug">
  .container
    location-select.form-control(type="account")
    location-select.form-control(type="territory")
    location-select.form-control(type="division")
    location-select.form-control(type="district")
    location-select.form-control(type="region")
    location-select.form-control(type="office")
</template>

<script>
import LocationSelect from '@/components/LocationSelect'

export default {
  name: 'home',
  components: {
    LocationSelect
  }
}
</script>
